function createMailgunEmailRemote(fieldSelector, additionalData) {
    return {
        url: "/api/UserAccountValidEmail",
        type: "post",
        data: $.extend({}, additionalData || {}, {
            Email: function () {
                return $(fieldSelector).val();
            },
            bypassMailgunValidation: function () {
                return $(fieldSelector).data('bypassMailgunValidation') === true;
            }
        }),
        dataFilter: function (data) {
            var parsed;
            try {
                parsed = JSON.parse(data);
            } catch (e) {
                $(fieldSelector).data('hasMailgunWarning', false);
                return data;
            }
            if (parsed && parsed.isValid === true) {
                $(fieldSelector).data('hasMailgunWarning', false);
                return JSON.stringify(true);
            }
            if (parsed && parsed.severity === 'warning') {
                $(fieldSelector).data('hasMailgunWarning', true);
                return JSON.stringify(parsed.message);
            }
            $(fieldSelector).data('hasMailgunWarning', false);
            return JSON.stringify(parsed.message || 'Email is invalid.');
        }
    };
}

function initMailgunBypass(formSelector, emailFieldSelectors) {
    $.each(emailFieldSelectors, function (i, sel) {
        $(sel).on('input change', function () {
            $(this).data('bypassMailgunValidation', false);
            $(this).data('hasMailgunWarning', false);
        });
    });

    $(formSelector).on('invalid-form.validate', function (event, validator) {
        if (!validator.errorList || validator.errorList.length === 0) {
            return;
        }

        var allErrorsAreMailgunWarnings = true;
        var fieldsToBypass = [];

        for (var i = 0; i < validator.errorList.length; i++) {
            var $el = $(validator.errorList[i].element);
            if ($el.data('hasMailgunWarning')) {
                fieldsToBypass.push($el);
            } else {
                allErrorsAreMailgunWarnings = false;
            }
        }

        if (allErrorsAreMailgunWarnings && fieldsToBypass.length > 0) {
            showConfirmationObj({
                confirmModalTitle: 'Please Double-Check Email Address',
                message: '<p>The email address you entered may not be valid. Please double-check for typos or misspellings.</p>' +
                    '<p>If you are sure it is correct, click <strong>Use This Email</strong> to continue.</p>',
                confirmButtonText: 'Use This Email',
                cancelButtonText: 'Go Back',
                confirmedAction: function () {
                    for (var j = 0; j < fieldsToBypass.length; j++) {
                        fieldsToBypass[j].data('bypassMailgunValidation', true);
                        fieldsToBypass[j].data('hasMailgunWarning', false);
                        fieldsToBypass[j].removeData('previousValue');
                    }
                    $(formSelector).submit();
                }
            });
        }
    });
}
